import React from "react";
import TransferSidebar from './TransferSidebar'
import "./TransferLocation.css";
import { Link } from 'react-router-dom'
import Autocompete from '../JobRequisition/Autocompete'
import TransferHeader from './TransferHeader'
  
  

const location = () => {
   
  return (
    <div className='location'>
      <TransferHeader/>
    <div class ="jobProcess">
    <TransferSidebar/>
    <div className="location">
     
     <div className="location-container">
        <h1>location Details</h1>
     <div className='location-title'>Location</div>
     <div className="location-ans"><Autocompete/></div></div>
     <div className="location-container">
     <div className='location-title'>Scheduled Weekly Hours<span className="mandatory">*</span></div>
     <div className="location-ans"> <input type ="number"/></div>
     </div>
    </div> 
   </div></div>
  );
}
export default location;